import ThisModule from "./Modal";

export default ThisModule;
